// Official brand mark silhouettes (single compound path, colored fill) — kept
// as tiny inline SVGs so Spotify/YouTube are instantly recognizable without a
// new icon-library dependency.

export function SpotifyIcon({ size = 18, className = "" }) {
  return (
    <svg viewBox="0 0 168 168" width={size} height={size} className={className} aria-hidden="true">
      <path
        fill="#1ED760"
        d="M83.996.277C37.747.277.253 37.77.253 84.019c0 46.251 37.494 83.741 83.743 83.741 46.254 0 83.744-37.49 83.744-83.741 0-46.246-37.49-83.738-83.744-83.738v-.004zm38.404 120.78a5.222 5.222 0 0 1-7.183 1.73c-19.662-12.01-44.414-14.73-73.564-8.07a5.225 5.225 0 0 1-6.242-3.93 5.213 5.213 0 0 1 3.926-6.245c31.9-7.288 59.263-4.15 81.337 9.334a5.22 5.22 0 0 1 1.726 7.18zm10.25-22.805a6.53 6.53 0 0 1-8.981 2.15c-22.505-13.837-56.822-17.842-83.397-9.76a6.535 6.535 0 0 1-8.157-4.35 6.53 6.53 0 0 1 4.354-8.156c30.365-9.216 68.068-4.75 93.86 11.126a6.53 6.53 0 0 1 2.32 8.99zm.88-23.744c-26.995-16.032-71.53-17.505-97.28-9.68a7.834 7.834 0 0 1-9.798-5.222 7.823 7.823 0 0 1 5.221-9.8c29.581-8.98 78.756-7.245 109.83 11.202a7.823 7.823 0 0 1 2.74 10.72 7.83 7.83 0 0 1-10.71 2.78z"
      />
    </svg>
  );
}

export function YouTubeIcon({ size = 18, className = "" }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
      <path
        fill="#FF0000"
        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
      />
    </svg>
  );
}
